import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ViewDataItem from '../../../../components/ViewDataItem';
import { FormattedMessage } from 'react-intl';
import dateFormatView from 'containers/App/screens/Foundation/utils/dateFormatView';

export default class InfoView extends Component {
  render() {
    const {
      basicInfo,
      fieldSettings,
    } = this.props;

    return (
      <div>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_LastName" defaultMessage="姓" />]} text={basicInfo.lastName}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_FirstName" defaultMessage="名" />]} text={basicInfo.firstName}/>
        {
          fieldSettings['0040'].isDisplay && <ViewDataItem label={[<FormattedMessage key="1" id="SH_EnglishName" defaultMessage="英文姓名" />]}text={basicInfo.englishName} />
        }
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_Nationality" defaultMessage="國藉" />]} text={basicInfo.nationText}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_Gender" defaultMessage="性別" />]} text={basicInfo.genderText}/>
        {
          fieldSettings['0060'].isDisplay &&
          <ViewDataItem label={[<FormattedMessage key="1" id="SH_MilitaryServiceStatus" defaultMessage="兵役狀態" />]} text={basicInfo.armyStatusText}/>
        }
        {
          fieldSettings['0060'].isDisplay && basicInfo.armyStatus !== '2' && basicInfo.armyStatus !== '3' &&
          <ViewDataItem label={[<FormattedMessage key="1" id="SH_MilitaryServiceType" defaultMessage="役別" />]} text={basicInfo.armyTypeText}/>
        }
        {
          fieldSettings['0060'].isDisplay
            && basicInfo.armyStatus !== '2'
            && basicInfo.armyStatus !== '3'
            && (
            <ViewDataItem
              label={[<FormattedMessage key="1" id="SH_MilitaryServicePeriod" defaultMessage="兵役期間" />]}
              text={
                dateFormatView(basicInfo, 'armyStart') + ' - ' + dateFormatView(basicInfo, 'armyEnd')
              }
            />
          )
        }
        {
          fieldSettings['0060'].isDisplay && basicInfo.armyStatus === '2' && basicInfo.armyStatus === '3' &&
          <ViewDataItem label={[<FormattedMessage key="1" id="SH_WaivedReason" defaultMessage="免役原因" />]} text={basicInfo.exemptReason} />
        }
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_IdentificationDocumentType" defaultMessage="識別證件類型" />]} text={basicInfo.iDTypeText}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_IdentificationDocumentNumber" defaultMessage="識別證件號碼" />]} text={basicInfo.iDNumber}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '' }} />]} text={dateFormatView(basicInfo, 'iDExpiryDate') }/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocType" defaultMessage="識別證件類型{0}" values={{ 0: '2' }} />]} text={basicInfo.iDType2}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocNumber" defaultMessage="識別證件號碼{0}" values={{ 0: '2' }} />]} text={basicInfo.iDNumber2}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '2' }} />]} text={dateFormatView(basicInfo, 'iDExpiryDate2') }/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocType" defaultMessage="識別證件類型{0}" values={{ 0: '3' }} />]} text={basicInfo.iDType3}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocNumber" defaultMessage="識別證件號碼{0}" values={{ 0: '3' }} />]} text={basicInfo.iDNumber3}/>
        <ViewDataItem label={[<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '3' }} />]} text={dateFormatView(basicInfo, 'iDExpiryDate3') }/>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_DateOfEntry" defaultMessage="入境時間" />]} text={ dateFormatView(basicInfo, 'entryTime') }/>
        <ViewDataItem label={[<FormattedMessage key="1" id="SH_DateOfBirth" defaultMessage="生日" />]} text={ dateFormatView(basicInfo, 'birthday') }/>
        {
          fieldSettings['0100'].isDisplay && <ViewDataItem label={[<FormattedMessage key="1" id="SH_MaterialStatus" defaultMessage="婚姻狀態" />]} text={basicInfo.maritalStatusText}/>
        }
        {this.props.children}
      </div>
    );
  }
}

InfoView.propTypes = {
  basicInfo: PropTypes.object.isRequired,
  children: PropTypes.array,
  fieldSettings: PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/BasicInfo/components/InfoView/index.js
 **/